import React from "react";
import { View,Text,StyleSheet } from "react-native";
const ResultBorodatiSimple=props=>{
    return(
<View style={styles.container}>
    <Text>مشاهده نتیجه بار برودتی - ساده</Text>
</View>
    )
}

export default ResultBorodatiSimple;
const styles=StyleSheet.create({
    container:{
        backgroundColor:'#fff',
        flex:1,
    }
})